module.exports = __webpack_public_path__ + "static/launchpadhero3-b2f3b438313f2280efd5df476492844b.jpg";